import { JsonObject, JsonProperty } from 'json2typescript';
import { PaginationAndSorting } from './pagination-and-sorting-model';

@JsonObject('CarrierFilters')
export class CarrierFilters extends PaginationAndSorting {
  @JsonProperty('name', String, true) name: string = undefined;
}
